@if (isLoading) {
  <div class='sideBarContent content loading-spinner'></div>
}
@if (!isLoading) {
  <div class="sideBarContent editModelDetailComponent content">
    <irb-editor-sidebar-banner
      (cancel)="cancel()"
      (save)="save()"
      [accordian]="accordian"
      [hasPendingFunction]="hasPendingFunction"
      [isModified]="isModified"
      [isValid]="isValid"
      [showUnsavedChangesWarning]="showUnsavedChangesWarning"
      [slot]="slot">
      <span header class="ms-header" tooltip [tooltipTitle]="modelTitle" [tooltipRequiresTruncation]="true">
        {{ modelTitle }}
      </span>
      <span buttonsInFront>
        @if (userDetails && userDetails.isMMCAdmin && data && data.status === 'Published') {
          <button class="btn-medium-primary"
            id="editormmcUnpublishButton"
          [disabled]="isModified || data.isProcessing || data.isFailed" (click)="unPublish()">Unpublish</button>
        }
        @if (userDetails && userDetails.isMMCAdmin && data && data.status === 'Unpublished') {
          <button class="btn-medium-primary"
            id="editormmcPublishButton"
          [disabled]="isPublishButtonDisabled" (click)="publish()">Publish</button>
        }
        @if (userDetails && userDetails.isMMCAdmin && data && data.status === 'Unpublished') {
          <button class="btn-medium-secondary"
            id="editormmcDeleteButton" style="width: 100px;"
          (click)="deleteUnPublish()">Delete</button>
        }
        @if (data && data.isFailed) {
          <button class="btn-medium-secondary"
            style="width: 100px;"
          [disabled]="isModified" (click)="resubmit()">Resubmit</button>
        }
      </span>
    </irb-editor-sidebar-banner>
    <div #body [style.height]="bodyHeight" style="padding-bottom:20px;" class="irb-editors-edit-model body">
      @if (modelTitle === 'Add Model') {
        <div class="block">
          When you create a new model, please e-mail the Managed Accounts Product Team to publish it to the Model Market Center.
        </div>
      }
      @if (modelTitle === 'Edit Model') {
        <div class="block">
          <strong>Please note:</strong> Any saved edits will be immediately seen by advisors using&nbsp;iRebal.
          <div style="float: right">@if (data && !data.isProcessing) {
            <a class="nav-link-text" (click)="openInModelMarketCenter()">View your model in the Model Market Center</a>
          }</div>
        </div>
      }
      <mat-accordion #accordian="matAccordion" [multi]="true">
        <mat-expansion-panel (closed)="localEditorService.updateExpansionState('OVERVIEWMMCMODEL','closed')"
          (opened)="localEditorService.updateExpansionState('OVERVIEWMMCMODEL','opened')"
          [expanded]="localEditorService.getDefaultExpansionState('OVERVIEWMMCMODEL')"
          id="OVERVIEWMMCMODEL">
          <mat-expansion-panel-header>
            <mat-panel-title>
              Model Overview
            </mat-panel-title>
          </mat-expansion-panel-header>
          <ng-template matExpansionPanelContent>
            @if (data && !donotshow && !isCustomModelEnabled) {
              <irb-mmc-overview-model [(data)]="data" (change)="onInputChange()"
                (validChange)="onValidChange($event)"
              [eventModelType]="eventModelType"></irb-mmc-overview-model>
            }
            @if (data && !donotshow && isCustomModelEnabled) {
              <irb-custom-overview-model [(data)]="data" (change)="onInputChange()"
                (validChange)="onValidChange($event)"
              [eventModelType]="eventModelType"></irb-custom-overview-model>
            }
          </ng-template>
        </mat-expansion-panel>
        <mat-expansion-panel (closed)="localEditorService.updateExpansionState('SECURITIESMMCMODEL','closed')"
          (opened)="localEditorService.updateExpansionState('SECURITIESMMCMODEL','opened')"
          [expanded]="localEditorService.getDefaultExpansionState('SECURITIESMMCMODEL')"
          id="SECURITIESMMCMODEL">
          <mat-expansion-panel-header>
            <mat-panel-title>
              Security Allocations
            </mat-panel-title>
          </mat-expansion-panel-header>
          <ng-template matExpansionPanelContent>
            @if (data && !donotshow) {
              <irb-mmc-securities-model [(data)]="data" (change)="onInputChange()"
                (validChange)="onValidChange($event)"
              [eventModelType]="eventModelType"></irb-mmc-securities-model>
            }
          </ng-template>
        </mat-expansion-panel>
        @if (userDetails.isMMCAdmin) {
          <div id="MARKETINGDOCUMENTSMMCMODEL" class="marketing-documents-panel">Marketing Documents@if (eventModelType !== 'editMmcModel') {
            <span class="mmc-marketing-text">You can provide marketing documents after the model is saved.</span>
          }
          @if (eventModelType === 'editMmcModel') {
            <span class="mmc-marketing-link">@if (data && !data.isProcessing) {
              <span style="margin-right: 10px;"><a class="nav-link-text" (click)="onViewMarketingDocuments()" >View/Edit Marketing Documents</a></span>
            }  ({{ (marketingDocuments ? marketingDocuments.length: 0)+ (data?.isPaidForModel?' currently linked':' currently linked')}})</span>
          }
        </div>
      }
      @if (userDetails.isModelProvider) {
        <mat-expansion-panel (closed)="localEditorService.updateExpansionState('OVERVIEWDOCUMENTS','closed')"
          (opened)="localEditorService.updateExpansionState('OVERVIEWDOCUMENTS','opened')"
          [expanded]="localEditorService.getDefaultExpansionState('OVERVIEWDOCUMENTS')"
          id="OVERVIEWDOCUMENTS">
          <mat-expansion-panel-header>
            <mat-panel-title>
              Overview Documents / Marketing Materials
            </mat-panel-title>
          </mat-expansion-panel-header>
          <ng-template matExpansionPanelContent>
            <irb-mmc-overview-marketing-documents [modelData]="data"></irb-mmc-overview-marketing-documents>
          </ng-template>
        </mat-expansion-panel>
      }
      <mat-expansion-panel (closed)="localEditorService.updateExpansionState('PERFORMANCEMMCMODEL','closed')"
        (opened)="localEditorService.updateExpansionState('PERFORMANCEMMCMODEL','opened')"
        [expanded]="localEditorService.getDefaultExpansionState('PERFORMANCEMMCMODEL')"
        id="PERFORMANCEMMCMODEL">
        <mat-expansion-panel-header>
          <mat-panel-title>
            Performance
          </mat-panel-title>
        </mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
          @if (data && !donotshow) {
            <irb-mmc-performance-model [(data)]="data" (change)="onInputChange()"
              (validChange)="onValidChange($event)"
            [eventModelType]="eventModelType"></irb-mmc-performance-model>
          }
        </ng-template>
      </mat-expansion-panel>
      <mat-expansion-panel (closed)="localEditorService.updateExpansionState('BACKCOSTMMCMODEL','closed')"
        (opened)="localEditorService.updateExpansionState('BACKCOSTMMCMODEL','opened')"
        [expanded]="localEditorService.getDefaultExpansionState('BACKCOSTMMCMODEL')"
        id="BACKCOSTMMCMODEL">
        <mat-expansion-panel-header>
          <mat-panel-title>
            Background & Cost
          </mat-panel-title>
        </mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
          @if (data && !donotshow) {
            <irb-mmc-background-cost-model [(data)]="data" (change)="onInputChange()"
              (validChange)="onValidChange($event)"
            [eventModelType]="eventModelType"></irb-mmc-background-cost-model>
          }
        </ng-template>
      </mat-expansion-panel>
      @if (eventModelType === 'editMmcModel' && userDetails && userDetails.isMMCAdmin) {
        <mat-expansion-panel (closed)="localEditorService.updateExpansionState('MODELMMCADMINENVIRONMENT','closed')"
          (opened)="localEditorService.updateExpansionState('MODELMMCADMINENVIRONMENT','opened')"
          [expanded]="localEditorService.getDefaultExpansionState('MODELMMCADMINENVIRONMENT')"
          id="MODELMMCADMINENVIRONMENT"
          >
          <mat-expansion-panel-header>
            <mat-panel-title>
              Environments
            </mat-panel-title>
          </mat-expansion-panel-header>
          <ng-template matExpansionPanelContent>
            @if (data) {
              <textarea rows="4" cols="100" [(ngModel)]="environments" (input)="validateEnvironment($event)"
              class="ui-inputtext" [disabled]="data.isProcessing"></textarea>
            }
          </ng-template>
        </mat-expansion-panel>
      }
      @if (eventModelType === 'editMmcModel') {
        <mat-expansion-panel (closed)="localEditorService.updateExpansionState('MODELHISTORYMMCMODEL','closed')"
          (opened)="localEditorService.updateExpansionState('MODELHISTORYMMCMODEL','opened')"
          [expanded]="localEditorService.getDefaultExpansionState('MODELHISTORYMMCMODEL')"
          id="MODELHISTORYMMCMODEL" >
          <mat-expansion-panel-header>
            <mat-panel-title>
              Model History
            </mat-panel-title>
          </mat-expansion-panel-header>
          <ng-template matExpansionPanelContent>
            @if (!donotshow) {
              <irb-mmc-model-history [data]="modelHistoryData" [eventModelType]="eventModelType"
              ></irb-mmc-model-history>
            }
          </ng-template>
        </mat-expansion-panel>
      }
    </mat-accordion>
    <div style="height: 10px; visibility:hidden"></div>
  </div>
</div>
}




